import React from "react";
import "../styles/legal.css";

export default function ReturnPolicyPage() {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>Return Policy</h1>
        <p>Last updated: {new Date().toLocaleDateString()}</p>
      </div>

      <div className="legal-content">
        <section>
          <h2>1. Return Eligibility</h2>
          <p>
            Items can be returned within 14 days of delivery if they meet the following conditions:
          </p>
          <ul>
            <li>Item must be unused and in original condition</li>
            <li>All original packaging and accessories must be included</li>
            <li>Item must not have been damaged by the buyer</li>
            <li>Receipt or proof of purchase must be available</li>
          </ul>
        </section>

        <section>
          <h2>2. Non-Returnable Items</h2>
          <p>
            The following items cannot be returned:
          </p>
          <ul>
            <li>Items damaged due to buyer negligence or misuse</li>
            <li>Items used for more than 30 days</li>
            <li>Items with missing or damaged barcodes/serial numbers</li>
            <li>Items purchased on clearance or final sale</li>
            <li>Customized or personalized items</li>
            <li>Perishable goods</li>
            <li>Items without original packaging</li>
          </ul>
        </section>

        <section>
          <h2>3. Return Process</h2>
          <p>
            To initiate a return:
          </p>
          <ul>
            <li>Log in to your Afriport account</li>
            <li>Navigate to "Returns" and select the order</li>
            <li>Choose the item and reason for return</li>
            <li>Provide any additional details</li>
            <li>Submit the return request</li>
            <li>Await approval from our support team</li>
          </ul>
        </section>

        <section>
          <h2>4. Inspection and Processing</h2>
          <p>
            Once we receive your returned item, we will inspect it within 5-7 business days. If the item meets our return criteria:
          </p>
          <ul>
            <li>We will process your refund immediately</li>
            <li>Refund will be issued to your original payment method</li>
            <li>Bank processing may take 5-10 business days</li>
          </ul>
          <p>
            If the item does not meet return criteria, we will contact you within 7 days to discuss options.
          </p>
        </section>

        <section>
          <h2>5. Shipping for Returns</h2>
          <p>
            <strong>For Items Under ₦5,000:</strong> Buyer pays return shipping
          </p>
          <p>
            <strong>For Items ₦5,000 and Above:</strong> Afriport covers return shipping. We will provide a prepaid shipping label via email.
          </p>
        </section>

        <section>
          <h2>6. Defective or Damaged Items</h2>
          <p>
            If your item arrives defective or damaged:
          </p>
          <ul>
            <li>Report the issue within 48 hours of delivery</li>
            <li>Include clear photos of the damage</li>
            <li>We will arrange a free return and replacement</li>
            <li>Return shipping will be fully covered by Afriport</li>
          </ul>
        </section>

        <section>
          <h2>7. Wrong Item or Missing Items</h2>
          <p>
            If you received the wrong item or items are missing from your order:
          </p>
          <ul>
            <li>Contact us within 48 hours of delivery</li>
            <li>Provide order number and clear description of issue</li>
            <li>We will send the correct item or missing items immediately</li>
            <li>No need to return the wrong item (unless requested)</li>
          </ul>
        </section>

        <section>
          <h2>8. Refund Methods</h2>
          <p>
            Refunds are issued to your original payment method:
          </p>
          <ul>
            <li><strong>Credit Card:</strong> 5-10 business days</li>
            <li><strong>Debit Card:</strong> 5-10 business days</li>
            <li><strong>Bank Transfer:</strong> 3-7 business days</li>
            <li><strong>Mobile Money:</strong> 1-3 business days</li>
          </ul>
        </section>

        <section>
          <h2>9. Return Authorization</h2>
          <p>
            All returns must be authorized before shipping. Unauthorized returns will not be accepted and may be returned to the sender at their expense.
          </p>
        </section>

        <section>
          <h2>10. Exceptions</h2>
          <p>
            The following conditions may result in denial of return:
          </p>
          <ul>
            <li>Return requested after 14-day window (except for defective items)</li>
            <li>Item shows signs of use or wear</li>
            <li>Packaging has been altered or damaged</li>
            <li>Item has been modified</li>
            <li>Return label not used or item not properly packaged</li>
          </ul>
        </section>

        <section>
          <h2>11. Quality Guarantee</h2>
          <p>
            We stand behind the quality of our products. If an item stops working within 30 days due to a manufacturing defect (not caused by the buyer), we will replace it at no cost.
          </p>
        </section>

        <section>
          <h2>12. Contact Support</h2>
          <p>
            Have questions about returns? Contact our support team:
          </p>
          <p>
            Email: support@afriportb2c.online<br />
            Phone: +234 915 589 6484<br />
            WhatsApp: +234 915 589 6484<br />
            Hours: Monday - Friday, 9 AM - 6 PM WAT
          </p>
        </section>

        <section>
          <h2>13. Policy Changes</h2>
          <p>
            We reserve the right to modify this return policy at any time. Changes will be effective immediately upon posting to the website. Your continued use of Afriport following the posting of revised terms means you accept and agree to the changes.
          </p>
        </section>
      </div>
    </div>
  );
}
